var productVariantCard = {

  elements: {},
  filterSelectors: [],

  init: function() {
    if(typeof BoosterTheme == 'undefined') {
        return;
    }

    if(!this.getElements()) {
      return;
    }

    this.filter();
    this.setEvents();
  },

  reInit: function() {
    if(!this.getElements()) {
      return;
    }

    this.filter();
  },

  getElements: function() {
    this.elements.wrappers = jQuery('.product-variant-card__wrapper');
    if(!this.elements.wrappers.length) {
      return false;
    }

    return true;
  },

  filter: function() {
    this.elements.wrappers.removeClass('product-variant-card__wrapper--disabled');

    if(!this.filterSelectors.length) {
      return;
    }

    var wrappersToEnable = this.elements.wrappers.children('.product-variant-card').filter(this.filterSelectors.join('')).parents('.product-variant-card__wrapper');

    this.elements.wrappers.not(wrappersToEnable).addClass('product-variant-card__wrapper--disabled');
  },

  setEvents: function() {
    var _self = this;

    BoosterTheme.ELEMENTS.events.on('booster:content:update', function() {
      _self.reInit();
    });
  }

};

function initProductVariantCard() {
  if(typeof BoosterTheme == 'undefined') {
    setTimeout(initProductVariantCard, 200);

    return;
  }

  productVariantCard.init();
}

jQuery(document).ready(function() {
  initProductVariantCard();
});